// eslint-disable-next-line import/no-unresolved
import { getCrmCustomerMeNewsletter } from 'data-api'
import { useApi } from '../useApi'
import { useUserData } from '../../providers/user/user-data'

export const useCustomerNewsletter = ({ options, paused } = {}) => {
	const { isLoggedIn } = useUserData()
	const { data, error, isValidating, mutate, cancel, cancelled } = useApi({
		method: getCrmCustomerMeNewsletter,
		options,
		paused: paused || !isLoggedIn,
	})

	return {
		subscribed: data,
		loading: isValidating,
		error,
		mutate,
		cancel,
		cancelled,
	}
}
